import {GameCenterHeaderModuleFetchHandler} from "./game-center-header-module.fetch-handler";
import {HandlerList} from "../../../../../infrastructure/handlers/handler-list";
import {TimingHandler} from "../../../../../infrastructure/handlers/timing-handler";
import {EntityClickEventHandler} from "../../../../../core/handlers/entity-click-event.handler";
import {GameContextCloseHandler} from "../../../../../core/handlers/game-context.close.handler";
import {GameCenterHeaderModuleChangeDescriptionEntityHandler} from "./game-center-header-module.change-description-entity.handler";
import {FullGamePopulateDataHandler} from "../../../../../core/handlers/full-game.populate-data.handler";

export class GameCenterHeaderModuleHandlers extends HandlerList {

  static injectables = [
    GameCenterHeaderModuleFetchHandler,
    GameCenterHeaderModuleChangeDescriptionEntityHandler,
    GameContextCloseHandler,
    EntityClickEventHandler,
    TimingHandler,
    FullGamePopulateDataHandler
  ];

  constructor(
    gameCenterHeaderModuleFetchHandler: GameCenterHeaderModuleFetchHandler,
    gameCenterHeaderModuleChangeDescriptionEntityHandler: GameCenterHeaderModuleChangeDescriptionEntityHandler,
    gameContextCloseHandler: GameContextCloseHandler,
    entityClickEventHandler: EntityClickEventHandler,
    timingHandler: TimingHandler,
    fullGamePopulateDataHandler: FullGamePopulateDataHandler) {
    super();

    [
      gameCenterHeaderModuleFetchHandler,
      gameCenterHeaderModuleChangeDescriptionEntityHandler,
      gameContextCloseHandler,
      entityClickEventHandler,
      timingHandler,
      fullGamePopulateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
